module.exports = __webpack_public_path__ + "public/img/xaioren.937f2ca3.png";